module.exports = __webpack_public_path__ + "static/media/kkm.0695c47d.jpg";